var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHashtag = function SvgHashtag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.259 1.135a.97.97 0 0 0-1.912-.33l-.53 3.074H1.94a.97.97 0 1 0 0 1.94h2.544l-.752 4.363H.97a.97.97 0 0 0 0 1.94h2.426l-.473 2.743a.97.97 0 1 0 1.911.33l.53-3.074h3.85l-.473 2.744a.97.97 0 1 0 1.912.33l.53-3.074h2.878a.97.97 0 1 0 0-1.94h-2.544l.752-4.363h2.761a.97.97 0 1 0 0-1.94h-2.426l.473-2.743a.97.97 0 1 0-1.912-.33l-.53 3.074h-3.85zM6.45 5.818l-.752 4.364h3.85l.752-4.364z",
    clipRule: "evenodd"
  })));
};
export default SvgHashtag;